var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"text-h3 mb-5"},[_vm._v("Добро пожаловать!")]),_c('p',[_vm._v(" Данный ресурс создан для себя и друзей себя :) ")])])}]

export { render, staticRenderFns }